export function filterSavedFeedbacks(data) {
  const subData = data?.filter((item) => {
    if (item.bookMarked == true) {
      return item;
    }
  });
  //console.log(subData);
  return subData;
}

//This function filters data branch wise but keeps same formate. of data
export function filterDataAtBranchLevel(data, activeBranches) {
  if (data == null) return null;

  const output = data.filter((item) => {
    if (activeBranches.includes(item.admin_id)) {
      return true;
    } else return false;
  });

  return output;
}

//this function filteres and organises data branchwise ..
//output format [{bId,data}]
export function filterSavedFeedbacksBranchWise(data, activeBranches) {
  //console.log(activeBranches);
  //console.log(data);
  if (data == null) return null;
  const output = [];
  activeBranches.forEach((bId) => {
    const d1 = data.filter((feedback) => {
      if (feedback.admin_id == bId) return true;
    });

    let obj = {
      bId: bId,
      data: d1,
    };
    output.push(obj);
  });

  //console.log(output);

  return output;
}
